/* eslint-disable */
var $ = window.jQuery = require('jquery');

import { mapGetters } from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'quiz-question-answer',
  components: {
  },
  props: [],
  data() {
    return {
      QuizList:null,
      quizDetailsEdit:null,
      editQuizQueAns:null,
      quizData:{
        courseId:''
      },
      coursesId:'',
      submitted:false,
      quizQuesList:'',
      removeQuizQueId:'',
      renderEq:true
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState'
    ]),
    getQuizQuesList() {
      this.quizQuesList = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesList
    },
  },
  mounted() {
    this.coursesId = this.$route.params.courseId;
    this.quizData.courseId = this.$route.params.quizId;
    this.renderMathJax()
  },
  methods: {
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub,this.$refs.mathJaxEl]);
        }
      },500)
      setTimeout(()=>{
        this.renderEq = false
      }, 1000)
    },
    getQuizQuesListAgain() {
      this.$store.dispatch('getQuizDetailsByIdFun', {
        id: this.$route.params.quizId
      }).then((res) => {
        this.quizQuesList = this.$store.getters.getQuizDetailsByIdDataState
      }).catch((err) => {})
    },
    removeQuizQueagain(id){
    $('#removQuizQueModalAgain').modal();
    this.removeQuizQueId = id
    },
    RemoveQuizQueConfirmationagain(){
      this.$store.dispatch('removeQuizQuesFun', {
        id: this.removeQuizQueId
      }).then((res) => {
        this.getQuizQuesListAgain()
        toast.success(res.data.msg);
      }).catch((err) => {})
    }
  },
  beforeMount() {
    this.renderMathJax()
  },
  watch: {
    'window.MathJax'(val){
      this.renderMathJax()
    },
    getQuizQuesList() {
      return this.$store.getters.getQuizDetailsByIdDataState
    },
  },
}